import React, { useContext } from 'react';
import {
    LanguageContext,
    roleContext,
    PayloadContext,
  } from "../../libs/context";
import { userFullName } from "../..//libs/utils";


const MobileUserInfo = (props) => {

    const avatarImg = "/images/icons/default-gray-user-avatar.png";

    return <div className="colBlock resSdnNavUsrInfo">
        <PayloadContext.Consumer>
            {({ payload }) => (
                <>
                <div className="resSdnNavUsrAvtr">
                    <img src={
                            payload?.profileImage?.url
                            ? payload?.profileImage?.url
                            : avatarImg
                        }
                        alt="Profile"
                        loading="lazy" />
                </div>
                <span className="resSdnvTxtL">{userFullName(payload)}</span>
                {payload && payload.email && <small className="resSdnvTxtS">{payload.email}</small>}
                </>
            )}
          </PayloadContext.Consumer>
    </div>

}

export default MobileUserInfo;